export const SEND_WINNER_EMAIL_START = 'SEND_WINNER_EMAIL_START';
export const SEND_WINNER_EMAIL_SUCCESS = 'SEND_WINNER_EMAIL_SUCCESS';
export const SEND_WINNER_EMAIL_FAIL = 'SEND_WINNER_EMAIL_FAIL';
export const SEND_WINNER_EMAIL_RESET = 'SEND_WINNER_EMAIL_RESET';
